import dr1 from "../../assets/images/doctors/01.jpg";
import dr2 from "../../assets/images/doctors/02.jpg";
import dr3 from "../../assets/images/doctors/03.jpg";
import dr4 from "../../assets/images/doctors/04.jpg";
import dr5 from "../../assets/images/doctors/05.jpg";
import dr6 from "../../assets/images/doctors/06.jpg";
import dr7 from "../../assets/images/doctors/07.jpg";
import dr8 from "../../assets/images/doctors/08.jpg";
import dr9 from "../../assets/images/doctors/09.jpg";
import dr10 from "../../assets/images/doctors/10.jpg";
import profile from "../../assets/images/doctors/profile-avatar.jpg";

export const DrTimeTable = () => {
  return (
    <section className="section bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="section-title text-center mb-4 pb-2">
              <span className="badge rounded-pill bg-soft-primary mb-3">
                Disponibilidad
              </span>
              <h4 className="title mb-4">Agenda Médica</h4>
              <p className="text-muted mx-auto para-desc mb-0">
                Visualiza la ocupación de agenda del equipo médico para valoraciones preanestésicas solo si es necesario y facilita la
                programación de procedimientos.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mt-4 pt-2">
            <div className="table-responsive shadow rounded">
              <table className="table table-center table-bordered bg-white mb-0">
                <thead>
                  <tr>
                    <th
                      className="text-center py-4"
                      style={{ minWidth: "120px" }}
                    >
                      Horarios de procedimientos
                    </th>
                    <th
                      className="text-center py-4"
                      style={{ minWidth: "200px" }}
                    >
                      Lunes
                    </th>
                    <th
                      className="text-center py-4"
                      style={{ minWidth: "200px" }}
                    >
                      Miercoles
                    </th>
                    <th
                      className="text-center py-4"
                      style={{ minWidth: "200px" }}
                    >
                      Viernes
                    </th>
                 
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="text-center py-5">09:00AM</th>
                    <td>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        09:00AM - 10:00AM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        10:00AM - 11:00AM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        11:00AM - 12:00PM
                      </small>
                    </td>
                    <td>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Slow Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-secondary rounded py-1 px-2 d-block text-center">
                        09:00AM - 12:00PM
                      </small>
                     
                    </td>
                    <td>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Slow Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-secondary rounded py-1 px-2 d-block text-center">
                        09:00AM - 12:00PM
                      </small>
                     
                    </td>
                  
                  </tr>

                  <tr>
                    <th className="text-center py-5">12:00PM</th>
                    <td>
                    <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        12:00PM - 1:00PM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        1:00PM - 2:00PM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        3:00PM - 2:00PM
                      </small>
                    </td>
                    <td>
                    <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        12:00PM - 1:00PM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        1:00PM - 2:00PM
                      </small>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Fast Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-primary rounded py-1 px-2 d-block text-center">
                        3:00PM - 2:00PM
                      </small>
                    </td>
                    <td>
                      <div className="d-flex mb-3">
                        <img
                          src={profile}
                          className="avatar avatar-md-sm rounded-circle border shadow"
                          alt=""
                        />
                        <div className="ms-3">
                          <h6 className="text-dark mb-0 d-block">Paciente</h6>
                          <small className="text-muted">Slow Track </small>
                        </div>
                      </div>
                      <small className="bg-soft-secondary rounded py-1 px-2 d-block text-center">
                        12:00PM - 3:00PM
                      </small>
                     
                    </td>
                  
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
